module.exports = __webpack_public_path__ + "img/poziom3.4a5f1c40.svg";